const baseUrl = '/api/v1';
export const API_ENDPOINTS = {
  REGISTER: `${baseUrl}/registration`,
  RESEND_VERIFICATION: `${baseUrl}/registration/send_confirmation_email`,
  LOGIN: `/sign_in`,
  PUT_PROFILE: `${baseUrl}/profile`,
  GET_PROFILE: `${baseUrl}/profile`,
  SIGN_IN_WITH_GOOGLE: `${baseUrl}/profile/sign_in_with_google`,
  PUT_PROFILE_ACTIVATE: `${baseUrl}/profile/activate`,
  DELETE_PROFILE_AVATAR: `${baseUrl}/profile/remove_avatar`,
  PUT_USER_BIO: `${baseUrl}/profile/bio`,
  GET_COMPANY: `${baseUrl}/company`,
  PUT_COMPANY: `${baseUrl}/company`,
  POST_UPLOAD_FILE: `${baseUrl}/uploads`,
  POST_INVITE_TEAM: `${baseUrl}/team/invite`,
  GET_TEAM_MEMBERS: `${baseUrl}/team/members`,
  GET_LEARNING_MATERIALS: `${baseUrl}/learning_materials`,
  GET_LEARNING_MATERIALS_COUNT: `${baseUrl}/learning_materials/count`,
  LEARNING_MATERIAL: (id) => `${baseUrl}/learning_materials/${id}`,
  DUPLICATE_LEARNING_MATERIAL: (id) => `${baseUrl}/learning_materials/${id}/duplicate`,
  PUT_LEARNING_MATERIAL_VISIBILITY: (id) =>
    `${baseUrl}/learning_materials/${id}/visibility`,
  UPLOAD_LEARNING_MATERIAL: (id) => `${baseUrl}/uploads/learning_materials/${id}`,
  GET_LEARNING_MATERIALS_AUDIENCE: `${baseUrl}/learning_materials/audience`,
  GET_WALKTHROUGH: (id) => `${baseUrl}/walkthroughs/${id}`,
  GET_LIBRARY_GALLERY: `${baseUrl}/library/gallery`,
  SEARCH_WALKTHROUGH: `${baseUrl}/walkthroughs/search`,
  PUBLISHED_DATA_WALKTHROUGH: (id) => `${baseUrl}/walkthroughs/${id}/published_data`,
  PUT_WALKTHROUGH: (id) => `${baseUrl}/walkthroughs/${id}`,
  PUT_WALKTHROUGH_SETTINGS: (id) => `${baseUrl}/walkthroughs/${id}/settings`,
  PUBLISH_WALKTHROUGH: (id) => `${baseUrl}/walkthroughs/${id}/publish`,
  GET_PATH: (id) => `${baseUrl}/paths/${id}`,
  PUT_PATH: (id) => `${baseUrl}/paths/${id}`,
  PUBLISH_PATH: (id) => `${baseUrl}/paths/${id}/publish`,
  GET_PATH_REMINDERS: (id) => `${baseUrl}/paths/${id}/reminders`,
  MATERIAL_RESPONSES: (slug) => `${baseUrl}/learning_materials/${slug}/responses`,
  MATERIAL_RESPONSES_LIST: `${baseUrl}/learning_materials/responses_list`,
  PUT_PATH_REMINDERS: (id) => `${baseUrl}/paths/${id}/reminders`,
  POST_DOMAIN: `${baseUrl}/domains`,
  GET_DOMAINS: `${baseUrl}/domains`,
  GET_DOMAINS_SIGN_PAGE_DETAILS: (id) => `${baseUrl}/domains/${id}/sign_in_page_design`,
  PUT_DOMAINS_SIGN_PAGE_DETAILS: (id) => `${baseUrl}/domains/${id}/sign_in_page_design`,
  SEND_MAGIC_LINK: `${baseUrl}/magic_link/generate`,
  DELETE_MATERIAL: (slug) => `${baseUrl}/learning_materials/${slug}`,
  PUT_WORKSPACE_NAME: `${baseUrl}/workspace`,
  DELETE_DOMAIN: (id) => `${baseUrl}/domains/${id}`,
  UPDATE_DOMAIN: (id) => `${baseUrl}/domains/${id}`,
  DOMAIN_STATUS: (id) => `${baseUrl}/domains/${id}/status`,
  SET_PRIMARY_DOMAIN: (id) => `${baseUrl}/domains/${id}/primary`,
  RECONNECT_DOMAIN: `${baseUrl}/domains/reconnect`,
  DOMAIN_LIMITS: `${baseUrl}/domains/limits`,
  GET_DASHBOARD_DATA: `${baseUrl}/dashboard`,
  GET_DASHBOARD_WIDGETS: `${baseUrl}/dashboard/widgets`,
  GET_DASHBOARD_NEEDS_ATTENTION: `${baseUrl}/dashboard/needs_attention`,
  GET_DASHBOARD_DROPOFF: `${baseUrl}/dashboard/dropoff`,
  DASHBOARD_DROPOFF_BULK_NUDGE: `${baseUrl}/dashboard/dropoff/bulk_nudge`,
  GET_PERSONALIZATION_ATTRIBUTES: `${baseUrl}/personalization/attributes`,
  POST_PERSONALIZATION_ATTRIBUTE: `${baseUrl}/personalization/attributes`,
  DELETE_PERSONALIZATION_ATTRIBUTE: (id) => `${baseUrl}/personalization/attributes/${id}`,
  SEND_PATH_NUDGE: (id, lmId) => `${baseUrl}/audiences/${id}/paths/${lmId}/nudge`,
  GET_MANAGE_ACCESS: `${baseUrl}/manage_access`,
  GET_AUDIENCES: `${baseUrl}/audiences`,
  POST_MATERIAL_INVITES: `${baseUrl}/material_invites`,
  BULK_REVOKE_MATERIAL_INVITES: `${baseUrl}/material_invites/bulk_revoke`,
  DELETE_MATERIAL_INVITE: (id) => `${baseUrl}/material_invites/${id}`,
  POST_AUDIENCE_IMPORTS: `${baseUrl}/audience_imports`,
  GET_CHECKLIST: (id) => `${baseUrl}/checklists/${id}`,
  PUT_CHECKLIST: (id) => `${baseUrl}/checklists/${id}`,
  PUBLISH_CHECKLIST: (id) => `${baseUrl}/checklists/${id}/publish`,
  DISTRIBUTE_CHECKLIST: (id) => `${baseUrl}/checklists/${id}/distribute`,
  GET_DOC: (id) => `${baseUrl}/docs/${id}`,
  PUT_DOC: (id) => `${baseUrl}/docs/${id}`,
  PUBLISH_DOC: (id) => `${baseUrl}/docs/${id}/publish`,
};

const hubBaseUrl = '/api/v1/hub';
export const HUB_ENDPOINTS = {
  GET_MATERIALS: `${hubBaseUrl}/materials`,
  GET_COMPANY_DETAILS: `${hubBaseUrl}/company`,
  GET_MATERIAL: (slug) => `${hubBaseUrl}/materials/${slug}`,
  GET_CHECKLIST: (slug) => `${hubBaseUrl}/checklists/${slug}`,
  GET_DOC: (slug) => `${hubBaseUrl}/docs/${slug}`,
  DOC_SECTION_PROGRESS: (slug) => `${hubBaseUrl}/docs/${slug}/section_progress`,
  GET_MATERIAL_SEARCH: `${hubBaseUrl}/search`,
  UPDATE_CURRENT_USER: `${hubBaseUrl}/update_current_user`,
  SAVE_RESPONSE: (id) => `${hubBaseUrl}/save_response/${id}`,
  SAVE_CURRENT_STEP: (id) => `${hubBaseUrl}/save_material_step/${id}`,
  SET_STEP_STATUS: (id) => `${hubBaseUrl}/step_status/${id}`,
  GET_RESPONSE: (id) => `${hubBaseUrl}/fetch_response/${id}`,
  SAVE_FILE: (id) => `${hubBaseUrl}/save_file/${id}`,
};

export const HUB_VIEW_ENDPOINTS = {
  VIEW_MATERIAL: (company_slug, slug) => `/${company_slug}/hub/${slug}`,
};

export const ENDPOINTS = {
  LOGIN: `/sign_in`,
  USER_SIGNOUT: `/sign_out`,
  EDIT_PROFILE: (company_slug) => `/${company_slug}/settings/profile`,
  VIEW_WALKTHROUGH: (company_slug, slug) => `/${company_slug}/walkthroughs/${slug}`,
  PREVIEW_WALKTHROUGH: (company_slug, slug) => `/${company_slug}/walkthroughs/${slug}/preview`,
  FULL_VIEW_WALKTHROUGH: (company_slug, slug) => `/${company_slug}/walkthroughs/${slug}/full_view`,
  EDIT_WALKTHROUGH: (company_slug, slug) => `/${company_slug}/walkthroughs/${slug}/edit`,
  VIEW_PATH: (company_slug, slug) => `/${company_slug}/paths/${slug}`,
  EDIT_PATH: (company_slug, slug) => `/${company_slug}/paths/${slug}/edit`,
  REMINDERS_PATH: (company_slug, slug) => `/${company_slug}/paths/${slug}/reminders`,
  VIEW_CHECKLIST: (company_slug, slug) => `/${company_slug}/checklists/${slug}`,
  EDIT_CHECKLIST: (company_slug, slug) => `/${company_slug}/checklists/${slug}/edit`,
  VIEW_DOC: (company_slug, slug) => `/${company_slug}/docs/${slug}`,
  EDIT_DOC: (company_slug, slug) => `/${company_slug}/docs/${slug}/edit`,
  VIEW_LEARNING_MATERIALS: (slug) => `/${slug}/learning_materials`,
  ONBOARDING: `/onboarding`,
  ROOT: `/`
};

export const INTERNAL_ENDPOINTS = {
  POST_LIBRARY: `${baseUrl}/library`
};

export const CONSTS = {
  AUTH_TOKEN: 'auth_token',
  AUDIENCE_TOKEN: 'aud_token',
  WALKTHROUGH: 'walkthrough',
  VIDEO: 'video',
  PATH: 'path',
  WALKTHROUGHS: 'walkthroughs',
  VIDEOS: 'videos',
  PATHS: 'paths',
  DOCS: 'docs',
  CHECKLIST: 'checklist',
  CHECKLISTS: 'checklists'
};
